import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7888bcac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "authForm__h1" }, "2-step Verification", -1))
const _hoisted_3 = { class: "authForm__p" }
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between"} }

import { computed, onMounted, ref, watch } from 'vue';
import { CodeInput, Button } from '@/v2/shared/ui';



export default /*#__PURE__*/_defineComponent({
  __name: 'CodeInputWithTimer',
  props: {
  title: {
    type: String,
    default: '',
  },
  show_logo: {
    type: Boolean,
    default: true,
  },
  support_email: {
    type: String,
    default: 'support@rocketdoc.co.uk'
  },
  to: {
    type: String,
    default: ''
  },
  resend_time: {
    type: Number,
    default: 30
  },
  num_inputs: {
    type: Number,
    default: 6
  },
  resendCodeCallback: {
    type: Function,
    required: true
  }
},
  emits: {
  'update:value': (value: string) => typeof value === 'string',
  'complete': (value: string) => typeof value === 'string',
  'resendCode': () => true
},
  setup(__props, { emit: __emit }) {

const props = __props;

const value = ref('');
const codeValid = ref();
const disable_time = ref(props.resend_time);
const disable_time_formatted = computed(()=>{
  const minutes = Math.floor(disable_time.value / 60).toString().padStart(2, '0');
  const seconds = (disable_time.value % 60).toString().padStart(2, '0');
  return `${minutes}:${seconds}`;
})

const sendCodeHandler = async () => {
  const result = await props.resendCodeCallback()
  if(result.success){
    disable_time.value = props.resend_time;
    value.value = '';
    emit('update:value', '');
  }
}

watch(()=>props.resend_time, (newVal)=>{
  disable_time.value = newVal;
})

onMounted(()=>{
  // const timestamp_code = localStorage.getItem('timestamp_code');
  // if(timestamp_code){
  //   const diff = Math.floor((Date.now() - parseInt(timestamp_code)) / 1000);
  //   if(diff < props.resend_time){
  //     disable_time.value = props.resend_time - diff;
  //   } else {
  //     localStorage.setItem('timestamp_code', Date.now().toString());
  //     disable_time.value = props.resend_time
  //   }
  // } else {
  //   localStorage.setItem('timestamp_code', Date.now().toString());
  // }
  setInterval(()=>{
    if(disable_time.value > 0){
      disable_time.value--;
    }
  }, 1000)
})

const emit = __emit;

const emitValue = () => {
  emit('update:value', value.value);
};

watch(value, emitValue, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, "An email with a verification code was just sent to " + _toDisplayString(__props.to.replace(/\s/g, ' ')), 1),
    _createVNode(_unref(CodeInput), {
      onComplete: _cache[0] || (_cache[0] = (value) => emit('complete', value)),
      value: value.value,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
      num_inputs: __props.num_inputs,
      onValidation: _cache[2] || (_cache[2] = ($event: any) => {codeValid.value = $event;}),
      parent_value: value.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (__props.resend_time)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                type: "link",
                class: _normalizeClass(["resendTimer", {'resendTimer_active' : !disable_time.value}]),
                disabled: !!disable_time.value,
                onClick: sendCodeHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(disable_time.value ? disable_time_formatted.value : 'Send code again'), 1)
                ]),
                _: 1
              }, 8, ["class", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["value", "num_inputs", "parent_value"]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})